import AxiosConfig from '../utils/AxiosConfig';

class CompanyService {
  // Obtener todas las empresas
  async getCompanies(page = 1, pageSize = 10, searchTerm = '') {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString()
      });
      if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
        params.append('search', searchTerm.trim());
      }
      console.log('📋 GET /tenants - Obteniendo lista de tenants...', { page, pageSize, searchTerm });
      const response = await AxiosConfig.get(`/tenants?${params}`);
      const data = response.data.data;
      // Asegurarse de que siempre devolvamos un array
      let companies = [];
      if (Array.isArray(data)) {
        companies = data;
      } else if (data && Array.isArray(data.items)) {
        // Si viene paginado con items
        companies = data.items;
      } else if (data && Array.isArray(data.companies)) {
        // Si viene con companies
        companies = data.companies;
      } else {
        // Si no es un array, devolver array vacío
        console.warn('Response is not an array:', data);
        companies = [];
      }
      
      // Normalizar los datos y asegurar que todos tengan un id válido
      const normalizedCompanies = companies
        .filter((company) => {
          // Filtrar empresas sin id válido
          return company && (company.id !== null && company.id !== undefined);
        })
        .map((company) => ({
          ...company,
          id: typeof company.id === 'string' ? parseInt(company.id, 10) || company.id : company.id,
          // Asegurar que otros campos estén presentes
          name: company.name || '',
          domain: company.domain || '',
          siteDomains: company.siteDomains || '',
          templateId: company.templateId || 'basico',
          companyType: company.companyType || 1,
          isActive: company.isActive !== false,
          createdAt: company.createdAt || null
        }));
      
      console.log(`✅ GET /tenants - Se obtuvieron ${normalizedCompanies.length} tenant(s)`, normalizedCompanies);
      return normalizedCompanies;
    } catch (error) {
      console.error('❌ Error fetching companies:', error);
      // En caso de error, devolver array vacío en lugar de lanzar error
      return [];
    }
  }

  // Obtener una empresa específica por ID
  async getCompanyById(companyId) {
    try {
      const response = await AxiosConfig.get(`/tenants/${companyId}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching company:', error);
      throw error;
    }
  }

  // Crear una nueva empresa
  async createCompany(companyData) {
    try {
      const payload = {
        name: companyData.name,
        domain: companyData.domain,
        siteDomains: companyData.siteDomains || null,
        templateId: companyData.templateId || 'basico',
        companyType: companyData.companyType
      };
      // Timeout de 5 minutos (300000ms) ya que este proceso puede demorar mucho
      const response = await AxiosConfig.post('/tenants', payload, {
        timeout: 300000, // 5 minutos
        skipGlobalErrorRedirect: true
      });
      return response.data.data;
    } catch (error) {
      console.error('Error creating company:', error);
      throw error;
    }
  }

  // Actualizar una empresa
  async updateCompany(companyId, companyData) {
    try {
      const response = await AxiosConfig.put(`/tenants/${companyId}`, companyData);
      return response.data.data;
    } catch (error) {
      console.error('Error updating company:', error);
      throw error;
    }
  }

  // Eliminar una empresa
  async deleteCompany(companyId) {
    try {
      const response = await AxiosConfig.delete(`/tenants/${companyId}`, {
        timeout: 300000,
        skipGlobalErrorRedirect: true
      });
      return response.data.data;
    } catch (error) {
      console.error('Error deleting company:', error);
      throw error;
    }
  }

  async getCompanyDeletionPlan(companyId) {
    try {
      const response = await AxiosConfig.get(`/tenants/${companyId}/deletion-plan`, {
        skipGlobalErrorRedirect: true
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching company deletion plan:', error);
      throw error;
    }
  }

  async getAdminCredentials(companyId, password) {
    try {
      const response = await AxiosConfig.post(`/tenants/${companyId}/admin-credentials`, { password });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching admin credentials:', error);
      throw error;
    }
  }

  // Validar datos de empresa
  validateCompanyData(companyData) {
    const errors = {};

    if (!companyData.name || companyData.name.trim() === '') {
      errors.name = 'El nombre de la empresa es requerido';
    }

    if (!companyData.domain || companyData.domain.trim() === '') {
      errors.domain = 'El dominio es requerido';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
}

export default new CompanyService();
